import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { __rest as e } from "../_virtual/_tslib.js";
import { jsxs as n, jsx as t } from "react/jsx-runtime";
import { Fonts as i } from "@vds-core/typography";
import { calculateRem as o, withVDSManager as r } from "@vds-core/utilities";
import { AccessibilityTokens as a } from "@vds-tokens/accessibility";
import { ColorTokens as l } from "@vds-tokens/color";
import { TypographyTokens as d } from "@vds-tokens/typography";
import s from "styled-components";
var u = a.color.focusring.onlight.value,
  c = a.color.focusring.ondark.value,
  f = d.fontweight.regular.value,
  p = d.fontweight.bold.value,
  h = d.lineheight.body[20].value,
  b = o(44),
  v = a.focusring.borderwidth.value,
  g = a.focusring.space.offset.value,
  y = function y(e) {
    return {
      default: "dark" === e ? l.elements.primary.ondark.value : l.elements.primary.onlight.value,
      hover: "dark" === e ? l.elements.primary.ondark.value : l.elements.primary.onlight.value,
      active: "dark" === e ? l.interactive.active.ondark.value : l.interactive.active.onlight.value,
      disabled: "dark" === e ? l.interactive.disabled.ondark.value : l.interactive.disabled.onlight.value
    };
  },
  m = function m(e, n) {
    var t = "0px";
    return "large" === e && "desktop" === n && (t = d.letterspacing.wide.value), t;
  },
  $ = s.span.withConfig({
    displayName: "HitArea",
    componentId: "VDS__sc-2pjk45-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: content-box;\n  cursor: pointer;\n  display: inline;\n  height: ", ";\n  left: 50%;\n  outline: none;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), function (_ref) {
    var e = _ref.type;
    return "inline" === e ? "1.2em" : b;
  }),
  k = s.span.withConfig({
    displayName: "Wrapper",
    componentId: "VDS__sc-2pjk45-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", ";\n  width: 100%;\n  position: relative;\n\n  &:focus {\n    outline: none;\n  }\n"])), function (_ref2) {
    var e = _ref2.type;
    return "inline" === e ? "inherit" : o(h);
  }),
  x = s.a.withConfig({
    displayName: "StyledAnchor",
    componentId: "VDS__sc-2pjk45-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-image: none;\n  place-self: center;\n  background-color: transparent;\n  border: 0;\n  border-bottom: ", ";\n  box-sizing: border-box;\n  color: ", ";\n  cursor: pointer;\n  outline: none;\n  position: relative;\n  text-decoration: none;\n  touch-action: manipulation;\n  transition: opacity ", " ease-in;\n  width: auto;\n  pointer-events: auto;\n  -webkit-tap-highlight-color: transparent;\n  ", ";\n\n  ", "\n\n  ", "\n  outline: none;\n  &:focus:not(:hover) ", " {\n    outline: ", ";\n    outline-offset: ", ";\n    border-radius: ", ";\n    padding-bottom: 2px; // Padding top & bottom required to fix the focus ring height\n    padding-top: 1px;\n  }\n  &:focus:not(:hover):not(:focus-visible) {\n    &:after {\n      display: none; // Only display focus state on keyboard focus, not when radio button is clicked\n    }\n  }\n  &:hover {\n    color: ", ";\n    border-bottom: ", ";\n  }\n\n  &:active {\n    color: ", ";\n    border-bottom: ", ";\n  }\n\n  ", ";\n"])), function (_ref3) {
    var e = _ref3.underline;
    return e.default;
  }, function (_ref4) {
    var e = _ref4.colors;
    return e.default;
  }, "0.15s", function (_ref5) {
    var e = _ref5.size;
    return "large" === e ? "padding-bottom: 1px" : void 0;
  }, function (_ref6) {
    var e = _ref6.type;
    return "inline" === e && "\n    color: inherit;\n    border-color: inherit;\n    font-size: inherit;\n    font-family: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n    letter-spacing: inherit;\n  ";
  }, function (_ref7) {
    var e = _ref7.type,
      n = _ref7.$bold,
      t = _ref7.$fontStyles,
      r = _ref7.size;
    return "inline" !== e && "\n    font-size: ".concat(o(null == t ? void 0 : t.fontSize), ";\n    font-family: ").concat("large" === r ? i.VerizonNHGeDS : i.VerizonNHGeTX, ";\n    font-weight: ").concat(n ? p : f, ";\n    line-height: ").concat(o(null == t ? void 0 : t.lineHeight), ";\n    letter-spacing: ").concat(o(null == t ? void 0 : t.letterSpacing), ";\n  ");
  }, k, function (_ref8) {
    var e = _ref8.surface;
    return function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
      var n = "inverted" === e ? c : u;
      return "".concat(o(v), " ").concat(a.focusring.borderstyle.value, " ").concat(n);
    }("dark" === e ? "inverted" : "default");
  }, o(parseInt(g, 10)), function (_ref9) {
    var e = _ref9.$focusRingBorderRadius;
    return e;
  }, function (_ref0) {
    var e = _ref0.colors;
    return e.hover;
  }, function (_ref1) {
    var e = _ref1.underline;
    return e.hover;
  }, function (_ref10) {
    var e = _ref10.colors;
    return e.active;
  }, function (_ref11) {
    var e = _ref11.underline;
    return e.active;
  }, function (_ref12) {
    var e = _ref12.disabled,
      n = _ref12.colors,
      t = _ref12.underline;
    return e && "\n    border-bottom: ".concat(t.disabled, ";\n    color: ").concat(n.disabled, ";\n    pointer-events: none;\n  ");
  }),
  w = function w(e) {
    return "small" === e ? d.fontsize.body[12].value : d.fontsize.body[16].value;
  },
  z = function z(e) {
    return "small" === e ? d.lineheight.body[16].value : d.lineheight.body[20].value;
  },
  R = function R(e, n, t) {
    var i = "inline" === e;
    return {
      fontSize: i ? "inherit" : w(t),
      lineHeight: i ? "inherit" : z(t),
      letterSpacing: i ? "inherit" : m(t, n)
    };
  },
  S = function S(i) {
    var r = i.id,
      a = i.disabled,
      l = i.dataLoc,
      d = i.tabIndex,
      s = i.role,
      u = i.surface,
      c = i.viewport,
      f = i.$focusRingBorderRadius,
      p = i.onClick,
      h = i.textLinkRef,
      b = e(i, ["id", "disabled", "dataLoc", "tabIndex", "role", "surface", "viewport", "$focusRingBorderRadius", "onClick", "textLinkRef"]),
      v = i.ariaLabel ? i.ariaLabel : i.children && "string" == typeof i.children ? i.children : "Text Link",
      g = y(u),
      m = function (e) {
        var n = y(e);
        return {
          default: "".concat(o(1), " solid ").concat(n.default),
          hover: "".concat(o(2), " solid ").concat(n.hover),
          active: "".concat(o(2), " solid ").concat(n.active),
          disabled: "".concat(o(1), " solid ").concat(n.disabled)
        };
      }(u),
      w = "tablet" === c ? "desktop" : c;
    return n(x, Object.assign({}, b, {
      ref: h,
      onClick: function onClick(e) {
        var n = e;
        if (n.target = e.currentTarget, p) return p(n);
      },
      id: r,
      type: i.type,
      disabled: a,
      surface: u,
      href: i.href,
      $bold: i.$bold,
      "aria-label": v,
      role: s,
      "aria-disabled": i.disabled,
      tabIndex: i.disabled ? -1 : d || 0,
      "data-loc": l,
      $fontStyles: R(i.type, w, i.size),
      colors: g,
      underline: m,
      $focusRingBorderRadius: f,
      onKeyDown: function onKeyDown(e) {
        i.onKeyDown && i.onKeyDown(e), "Enter" !== e.key && " " !== e.key || i.onClick && i.onClick(e);
      },
      children: [t($, {
        type: i.type,
        tabIndex: -1,
        "aria-hidden": !0
      }), t(k, {
        tabIndex: -1,
        "aria-hidden": !0,
        type: i.type,
        children: i.children
      })]
    }));
  };
S.defaultProps = {
  size: "large",
  viewport: "desktop",
  type: "inline",
  disabled: !1,
  surface: "light",
  $bold: !1,
  tabIndex: 0,
  role: "link",
  $focusRingBorderRadius: "2px"
};
var I = r(S);
export { I as default };